module.exports = __webpack_public_path__ + "img/CIC 主LOGO.2ac1c323.png";